import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType } from 'next'
import { POST, POSTS_SLUG } from '@/apollo/queries'
import { Post, PostVariables, Post_post } from '@/apollo/__generated__/Post'

import { ParsedUrlQuery } from 'querystring'
import { PostsSlug } from '@/apollo/__generated__/PostsSlug'
import client from '@/apollo/apollo-client'

export { Post as default } from '@/page-components/posts'

interface PostStaticPathsParams extends ParsedUrlQuery {
  slug: string
}

interface PostGetStaticProps {
  post: Post_post | null
}

export const getStaticPaths: GetStaticPaths<
  PostStaticPathsParams
> = async () => {
  const { data } = await client.query<PostsSlug>({ query: POSTS_SLUG })

  if (!data.posts) throw new Error('Post data undefined')

  const paths = data.posts.map((post) => {
    return {
      params: {
        slug: post.slug,
      },
    }
  })

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps: GetStaticProps<
  PostGetStaticProps,
  PostStaticPathsParams
> = async ({ params }) => {
  if (!params) throw new Error('Missing url params')

  const { data } = await client.query<Post, PostVariables>({
    query: POST,
    variables: { where: { slug: params.slug } },
  })

  return {
    props: {
      post: data.post,
    },
    revalidate: 1,
  }
}

export type PostStaticProps = InferGetStaticPropsType<typeof getStaticProps>
